import { Banner } from "../../components/ui/Banner";
import { skillscat } from "../../data/skills";
import { motion } from "framer-motion";
import { AnimatedSection } from "../../components/ui/AnimatedSection";

export const SkillsSection = () => {
    const container = {
        hidden: { opacity: 0 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1,
            },
        },
    };

    const item = {
        hidden: { opacity: 0, y: 20 },
        show: { opacity: 1, y: 0 },
    };

    return (
        <div className="flex flex-col space-y-4">
            {/* Banner */}
            <Banner title="Skills" />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 px-4 sm:px-10 mt-3">
                {/* Mobile Skills */}
                <AnimatedSection delay={0.1}>
                    <div className="h-full border border-button rounded p-5 flex flex-col gap-3">
                        <div>
                            <h2 className="font-semibold">Mobile</h2>
                            <p className="text-gray-400">Mobile stack</p>
                        </div>
                        <motion.div
                            className="flex flex-wrap gap-2 p-3 w-full bg-background rounded "
                            variants={container}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true }}
                        >
                            {skillscat.mobile.map((skill, index) => (
                                <motion.div
                                    key={index}
                                    className="flex flex-row items-center gap-2 px-3 py-1.5 bg-list-item rounded-md shadow-md"
                                    variants={item}
                                >
                                    <div className="p-1.5 rounded-full border-4 border-black/20 flex items-center justify-center">
                                        {skill.icon}
                                    </div>
                                    <span className="text-sm font-medium">
                                        {skill.title}
                                    </span>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </AnimatedSection>

                {/* Web Development Skills */}
                <AnimatedSection delay={0.2}>
                    <div className="h-full border border-button rounded p-5 flex flex-col gap-3">
                        <div>
                            <h2 className="font-semibold">Web Development</h2>
                            <p className="text-gray-400">
                                Web development stack
                            </p>
                        </div>
                        <motion.div
                            className="flex flex-wrap gap-2 p-3 w-full bg-background rounded "
                            variants={container}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true }}
                        >
                            {skillscat.web.map((skill, index) => (
                                <motion.div
                                    key={index}
                                    className="flex flex-row items-center gap-2 px-3 py-1.5 bg-list-item rounded-md shadow-md"
                                    variants={item}
                                >
                                    <div className="p-1.5 rounded-full border-4 border-black/20 flex items-center justify-center">
                                        {skill.icon}
                                    </div>
                                    <span className="text-sm font-medium">
                                        {skill.title}
                                    </span>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </AnimatedSection>

                {/* Backend Skills */}
                <AnimatedSection delay={0.3}>
                    <div className="h-full border border-button rounded p-5 flex flex-col gap-3">
                        <div>
                            <h2 className="font-semibold">Backend</h2>
                            <p className="text-gray-400">
                                Backend development skills
                            </p>
                        </div>
                        <motion.div
                            className="flex flex-wrap gap-2 p-3 w-full bg-background rounded "
                            variants={container}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true }}
                        >
                            {skillscat.backend.map((skill, index) => (
                                <motion.div
                                    key={index}
                                    className="flex flex-row items-center gap-2 px-3 py-1.5 bg-list-item rounded-md shadow-md"
                                    variants={item}
                                >
                                    <div className="p-1.5 rounded-full border-4 border-black/20 flex items-center justify-center">
                                        {skill.icon}
                                    </div>
                                    <span className="text-sm font-medium">
                                        {skill.title}
                                    </span>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </AnimatedSection>

                {/* Other Skills */}
                <AnimatedSection delay={0.4}>
                    <div className="h-full border border-button rounded p-5 flex flex-col gap-3">
                        <div>
                            <h2 className="font-semibold">Other skills</h2>
                            <p className="text-gray-400">
                                Additional tools and technologies
                            </p>
                        </div>
                        <motion.div
                            className="flex flex-wrap gap-2 p-3 w-full bg-background rounded "
                            variants={container}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true }}
                        >
                            {skillscat.other.map((skill, index) => (
                                <motion.div
                                    key={index}
                                    className="flex flex-row items-center gap-2 px-3 py-1.5 bg-list-item rounded-md shadow-md"
                                    variants={item}
                                >
                                    <div className="p-1.5 rounded-full border-4 border-black/20 flex items-center justify-center">
                                        {skill.icon}
                                    </div>
                                    <span className="text-sm font-medium">
                                        {skill.title}
                                    </span>
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </AnimatedSection>
            </div>
        </div>
    );
};
